import { P2GBox, P2GText, P2GDate, SvgInfo, P2GLink } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { BookingDetails } from '~/lib/api/smartsend/types';
import { ClaimRecord, GetClaimsForOrderLineId } from '../../../lib/cache/ExtendedOrderCache';
import AlertWithIcon from '../../AlertWithIcon';
import { SidePanelContent } from '~/components/sidepanel-section';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

interface props {
  bookingDetails: BookingDetails;
  onClick?: () => void;
}

const Claim = ({ r, goTo, onClick }: { r: ClaimRecord; goTo: (route: string) => void; onClick?: () => void }) => {
  const date = useMemo(() => {
    if (!r.created) {
      return null;
    }
    const d = r.created instanceof Date ? r.created : new Date(r.created);
    return isNaN(d.getTime()) ? null : d;
  }, [r.created]);

  return (
    <AlertWithIcon icon={<SvgInfo />} iconSrc="/theme/icons/ConfirmCircle.svg" color="error" key={r.orderlineId}>
      <SidePanelContent>
        <P2GText component="p">
          <strong>Claim Status: {r.status}</strong>
        </P2GText>
        <P2GText component="p" variant="caption">
          Claim Ref: {r.id}
          {date && (
            <>
              , Created <P2GDate variant="caption" date={date} size="large" />
            </>
          )}
        </P2GText>
        <P2GText>
          <P2GLink
            variant="body2"
            onClick={() => {
              goTo(`${RoutingConstants.Claims}/${r.id}`);
              onClick?.();
            }}
          >
            View Claim Details
          </P2GLink>
        </P2GText>
      </SidePanelContent>
    </AlertWithIcon>
  );
};

export default function ItemClaim(props: props) {
  const { goTo } = useGoto();

  const claims = useMemo(() => GetClaimsForOrderLineId(props.bookingDetails?.OrderLineId), [props.bookingDetails]);

  if (!props.bookingDetails || !props.bookingDetails?.OrderLineId || claims.length === 0) {
    return null;
  }

  return (
    <P2GBox>
      {claims.map((r) => (
        <Claim key={r.orderlineId} r={r} goTo={goTo} onClick={props.onClick} />
      ))}
    </P2GBox>
  );
}
